import React, { PropTypes } from "react";
import {
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
} from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const PasswordInput = (props, context) => {
  const {
    input,
    fieldDescription,
    label,
    meta: { touched, error },
    groupClassName,
    id,
    isStatic,
    mockPassword,
    required,
    ...rest
  } = props;
  const validationState = touched && !!error ? error.state : null;
  const validationMessageKey =
    !!error && error.messageKey ? error.messageKey : null;
  const validationValues = !!error && error.values ? error.values : null;
  const scene = context.scene ? "-" + context.scene : "";

  return (
    <FormGroup
      className={groupClassName}
      controlId={id + scene}
      validationState={validationState}
    >
      {label && (
        <ControlLabel>
          {label}
          {required ? <span className="required"> *</span> : ""}
        </ControlLabel>
      )}
      <div className="input-wrapper">
        {isStatic ? (
          <FormControl.Static>{props.value}</FormControl.Static>
        ) : (
          <FormControl
            {...input}
            {...rest}
            onChange={(e) => {
              props.onChange && props.onChange(e.target.value);
              return input.onChange(e.target.value);
            }}
            onClick={(e) => {
              mockPassword &&
                e.target.value === mockPassword &&
                input.onChange("");
            }}
            onBlur={(e) => {
              const value = e.target.value || mockPassword;
              !e.target.value && input.onChange(value);
              return input.onBlur(value);
            }}
          />
        )}
        {touched && error && (
          <HelpBlock>
            <FormattedMessage
              id={validationMessageKey}
              values={validationValues}
            />
          </HelpBlock>
        )}
        {fieldDescription && (
          <small className="form-text text-muted">{fieldDescription}</small>
        )}
      </div>
    </FormGroup>
  );
};

PasswordInput.propTypes = {
  fieldDescription: PropTypes.object,
  groupClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  isStatic: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.object.isRequired,
  mockPassword: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  type: PropTypes.string.isRequired,
  validation: PropTypes.object,
  validationKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

PasswordInput.contextTypes = {
  scene: PropTypes.string,
};

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/components/common/form/PasswordInput.js